import { Flex } from 'components'
import { Suspense, lazy } from 'react'
import { keyFromPath } from '../../../utils/templateBuilderUtils'
import { useTemplate } from '../TemplateProvider'
import { useTemplateLayout } from './TemplateLayoutProvider'

const EmbeddedLayout = lazy(() => import('desktop-app').then(m => ({ default: m.EmbeddedLayout })))

export default function LayoutViewer() {
  const { template } = useTemplate()
  const { rootLayout, selectedLayout, setSelectedKeyPath } = useTemplateLayout()

  if (!template || !rootLayout) return null

  const selectedKey = selectedLayout && keyFromPath(selectedLayout.keyPath)

  return (
    <Flex flex={1} overflow="hidden" borderRadius="md">
      <Suspense>
        <EmbeddedLayout
          template={template}
          layoutKey={Number(rootLayout.keyPath)}
          selectedKey={selectedKey}
          onClick={setSelectedKeyPath}
        />
      </Suspense>
    </Flex>
  )
}
